import { aiTagTracesResultSchema, type AiTagTracesResult } from '@xphoto/shared';
import { apiFetch } from '../lib/http';

/**
 * Client typé du JOURNAL DES APPELS IA (tagging de vision). La réponse est RE-PARSÉE via
 * son schéma partagé `@xphoto/shared` (« never trust the client »).
 */

/** `GET /api/libraries/:id/ai-tag/traces` — page de traces (prompt envoyé + réponse brute). */
export async function fetchAiTraces(
  libraryId: string,
  limit: number,
  offset: number,
  signal?: AbortSignal,
): Promise<AiTagTracesResult> {
  const res = await apiFetch(
    `/api/libraries/${libraryId}/ai-tag/traces?limit=${limit}&offset=${offset}`,
    { signal: signal ?? null },
  );
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return aiTagTracesResultSchema.parse(await res.json());
}
